import PropTypes from 'prop-types';
import React, { CSSProperties } from 'react';
import createReactClass from 'create-react-class';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Col, FormControl, Row } from 'react-bootstrap';
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ValidatorFormGroup from '../../main/validator-form-group';
import translate from '../../translate';

const VALIDATORS = {
    note: { isValid: (value) => `${value}`.length < 151 },
    washer_cost: {
        isValid: (value) => /^\s*\d{1,5}([.,]\d*)?$/.test(`${value}`),
    },
    dryer_cost: {
        isValid: (value) => /^\s*\d{1,5}([.,]\d*)?$/.test(`${value}`),
    },
};

const LocationCostsForm = createReactClass({
    displayName: 'LocationCostsForm',

    propTypes: {
        costs: PropTypes.shape({
            note: PropTypes.string,
            washer_cost: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]),
            dryer_cost: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]),
        }),
        handleChange: PropTypes.func.isRequired,
        forceValidation: PropTypes.bool,
        disabled: PropTypes.bool,
        forceDisable: PropTypes.bool,
        strings: PropTypes.object,
        selectedPartner: PropTypes.shape({}).isRequired,
    },

    defaultProps: {
        costs: {},
        disabled: false,
        forceDisable: false,
        forceValidation: false,
        strings: {
            note: 'Nutzerhinweis (optional)',
            note_notif: 'Das sehen Ihre Nutzer in der WeWash App.',
            washer_cost: 'Tarif für Waschmaschinen',
            note_washers: 'Preise in EUR pro Std.',
            dryer_cost: 'Tarif für Trockner',
            note_dryers: 'Preise in EUR pro Std.',
        },
    },

    getInitialState() {
        return _.extend(
            {
                note: '',
                washer_cost: '',
                dryer_cost: '',
                _dirty: {},
                _valid: true,
            },
            this.props.costs
        );
    },

    componentWillReceiveProps(nextProps) {
        if (JSON.stringify(nextProps) !== JSON.stringify(this.props)) {
            this.setState(nextProps.costs, this._persistState);
        }
    },

    _persistState() {
        const new_state = {};
        _.each(['note', 'washer_cost', 'dryer_cost'], (fieldName) => {
            new_state[fieldName] = this.state[fieldName];
        });
        // return valid state to parent
        new_state._valid = Object.keys(VALIDATORS).reduce(
            (formValid, fieldName) =>
                formValid &&
                VALIDATORS[fieldName].isValid(new_state[fieldName]),
            true
        );
        new_state.washer_cost = `${new_state.washer_cost}`.replace(',', '.');
        new_state.dryer_cost = `${new_state.dryer_cost}`.replace(',', '.');
        this.props.handleChange(new_state);
    },

    _markDirty(key) {
        const newDirt = {};
        newDirt[key] = true;
        const newState = _.extend({}, this.state, {
            _dirty: _.extend({}, this.state._dirty, newDirt),
        });
        this.setState(newState);
    },

    _handleFormChange(key, value) {
        this._markDirty(key);
        const newSt = _.set({}, key, value);
        newSt[key] = value;
        this.setState(newSt, this._persistState);
    },

    render() {
        const accountingArea = this.props.selectedPartner;
        const currency =
            this.props.strings._utils.getCurrencySymbolFromAccountingArea(
                accountingArea
            );
        return (
            <div>
                <Row className={'mb-2'}>
                    <Col xs={12} style={fontStyle}>
                        <a
                            href={this.props.strings.cost_calculator_link}
                            target={'_blank'}
                        >
                            <FontAwesomeIcon icon={faInfoCircle} size={'1x'} />{' '}
                            {this.props.strings.cost_calculator_action}
                        </a>
                    </Col>
                </Row>

                <Row>
                    <Col xs={6} sm={6} md={6} lg={6}>
                        <ValidatorFormGroup
                            label={this.props.strings._utils.sprintf(
                                this.props.strings.washer_cost,
                                currency
                            )}
                            hideErrorLabel={
                                !(
                                    this.state._dirty.washer_cost ||
                                    this.props.forceValidation
                                ) ||
                                VALIDATORS.washer_cost.isValid(
                                    this.state.washer_cost
                                )
                            }
                            errorLabel={this.props.strings.washer_cost_error}
                        >
                            <FormControl
                                type="text"
                                className="input-text-color"
                                value={this.state.washer_cost}
                                name="washer_cost"
                                data-testid="washer-cost-input"
                                onChange={(event) => {
                                    this._handleFormChange(
                                        'washer_cost',
                                        event.target.value
                                    );
                                }}
                                required
                                disabled={
                                    this.props.disabled ||
                                    this.props.forceDisable
                                }
                            />
                        </ValidatorFormGroup>
                    </Col>

                    <Col xs={6} sm={6} md={6} lg={6}>
                        <ValidatorFormGroup
                            label={this.props.strings._utils.sprintf(
                                this.props.strings.dryer_cost,
                                currency
                            )}
                            hideErrorLabel={
                                !(
                                    this.state._dirty.dryer_cost ||
                                    this.props.forceValidation
                                ) ||
                                VALIDATORS.dryer_cost.isValid(
                                    this.state.dryer_cost
                                )
                            }
                            errorLabel={this.props.strings.dryer_cost_error}
                        >
                            <FormControl
                                type="text"
                                className="input-text-color"
                                value={this.state.dryer_cost}
                                name="dryer_cost"
                                data-testid="dryer-cost-input"
                                onChange={(event) => {
                                    this._handleFormChange(
                                        'dryer_cost',
                                        event.target.value
                                    );
                                }}
                                required
                                disabled={
                                    this.props.disabled ||
                                    this.props.forceDisable
                                }
                            />
                        </ValidatorFormGroup>
                    </Col>
                </Row>

                <ValidatorFormGroup
                    label={this.props.strings.note}
                    hideErrorLabel={
                        !(
                            this.state._dirty.note || this.props.forceValidation
                        ) || VALIDATORS.note.isValid(this.state.note)
                    }
                    errorLabel={this.props.strings.note_error}
                >
                    <textarea
                        value={this.state.note}
                        className="form-control"
                        name="note"
                        rows="6"
                        onChange={(event) => {
                            this._handleFormChange('note', event.target.value);
                        }}
                        disabled={this.props.disabled}
                    />
                </ValidatorFormGroup>
            </div>
        );
    },
});
const fontStyle: CSSProperties = { fontStyle: 'italic' };
export default connect((store) => ({
    selectedPartner: store.partnerManager.selectedPartner,
}))(translate('LocationCostsForm')(LocationCostsForm));
